










import Vue from 'vue';
import { AppSettingsHelper } from '@/mixins/appSettingsHelper';

export default Vue.extend({
  name: 'MStoreItemsPerPage',
  mixins: [AppSettingsHelper],
  props: {
    itemsPerPage: {
      type: Number,
      required: false
    },
    emitFilters: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalItemsPerPage: 20
    };
  },
  methods: {
    initializePageOptions(this: any) {
      if (!this.itemsPerPage || this.localPageOptions.indexOf(this.itemsPerPage) === -1) {
        this.localItemsPerPage = this.paginationOptions?.defaultValue;
      }
    }
  },
  computed: {
    localItemsPerPage: {
      get(this: any): number {
        return this.emitFilters ? this.itemsPerPage : this.internalItemsPerPage;
      },
      set(this: any, value: any) {
        if (this.emitFilters) {
          this.$emit('update:items-per-page', value);
        } else {
          this.internalItemsPerPage = value;
        }
      }
    },
    localPageOptions(this: any) {
      if (this.pageOptions) {
        return this.pageOptions;
      }
      const PAGE_OPTIONS = [];
      for (let i = this.paginationOptions?.minValue; i <= this.paginationOptions?.maxValue; i = i + this.paginationOptions?.incrementBy) {
        PAGE_OPTIONS.push(i);
      }
      return PAGE_OPTIONS;
    }
  },
  mounted(this: any) {
    this.$nextTick(() => {
      this.initializePageOptions();
    });
  }
});
